import { Injectable } from '@angular/core';
import { Subject ,  Observable } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { Alert } from './alert';

@Injectable({ providedIn: 'root' })
export class AlertService {

  private errorSubject = new Subject<Alert | null>();
  private successSubject = new Subject<Alert | null>();

  // Keep after navigation change will be used to know if we want to keep the alert component (error or success)
  // After redirection
  private keepAfterNavigationChangeError = false;
  private keepAfterNavigationChangeSuccess = false;

  constructor(private router: Router) {
    // Clear alert message on route change
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChangeError) {
          this.keepAfterNavigationChangeError = false;
        } else {
          // clear alert
          this.errorSubject.next(null);
        }

        if (this.keepAfterNavigationChangeSuccess) {
          this.keepAfterNavigationChangeSuccess = false;
        } else {
          // clear alert
          this.successSubject.next(null);
        }
      }
    });
  }

  /**
   * Method call when error. Will notify error component.
   * @param type      -- Type of error that we want to show. It could be dialog, snackBar, alert.
   * @param message   -- Message to be displayed.
   * @param keepAfterNavigationChange
   */
  error(error, keepAfterNavigationChange = false, type = 'alert') {
    this.keepAfterNavigationChangeError = keepAfterNavigationChange;
    const alert = new Alert();
    alert.type = type;
    alert.message = error.developerMessage ? error.developerMessage : error;
    this.errorSubject.next(alert);
  }

  /**
   * Method call when success. Will notify success component.
   * @param type      -- Type of success that we want to show. It could be dialog, snackBar, alert.
   * @param message   -- Message to be displayed.
   * @param keepAfterNavigationChange
   */
  success(message: string, keepAfterNavigationChange = false, type = 'snackbar') {
    this.keepAfterNavigationChangeSuccess = keepAfterNavigationChange;
    const alert = new Alert();
    alert.type = type;
    alert.message = message;
    this.successSubject.next(alert);
  }

  /**
   * Returns observable of alert. Error component will subscribe to change on this.
   * @returns {Observable<Alert>}
   */
  getError(): Observable<Alert | null> {
    return this.errorSubject.asObservable();
  }

  /**
   * Returns observable of alert. Success (feedback) component will subscribe to change on this.
   * @returns {Observable<Alert>}
   */
  getSuccess(): Observable<Alert | null> {
    return this.successSubject.asObservable();
  }
}
